/**
 * Indicateur discret de l'état de sauvegarde du dashboard (bas-gauche, non bloquant).
 * « Enregistrement… » pendant l'écriture, « Enregistré » brièvement, « Échec » en cas d'erreur.
 */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDashboardSave } from "./DashboardSave";

export function DashboardSaveIndicator() {
  const { status } = useDashboardSave();

  if (status === "idle") return null;

  const saving = status === "pending" || status === "saving";

  return (
    <div className="fixed bottom-6 left-6 z-40 pointer-events-none">
      <div className="flex items-center gap-2 bg-white border border-grey-light rounded-full shadow-lg px-3 py-1.5 text-sm">
        {saving && (
          <>
            <FontAwesomeIcon
              icon="circle-notch"
              spin
              className="text-grey-medium"
            />
            <span className="text-grey-dark">Enregistrement…</span>
          </>
        )}
        {status === "saved" && (
          <>
            <FontAwesomeIcon icon="check" className="text-secondary" />
            <span className="text-grey-dark">Enregistré</span>
          </>
        )}
        {status === "error" && (
          <>
            <FontAwesomeIcon
              icon="triangle-exclamation"
              className="text-red-500"
            />
            <span className="text-red-500">Échec de l'enregistrement</span>
          </>
        )}
      </div>
    </div>
  );
}
